import ErrorBubble from './ErrorBubble'

export default ErrorBubble



// WEBPACK FOOTER //
// ./client/Components/Form/ErrorBubble/index.js